import $ from 'jquery'
import ScrollMagic from 'scrollmagic'

export default function () {
  const controller = new ScrollMagic.Controller()
  const offset = 20
  controller.scrollTo(function (newScrollPos) {
    $('html, body').animate({ scrollTop: newScrollPos }, 500)
  })

  const $link = $('.header__link')
  $link.on('click', function (e) {
    e.preventDefault()
    controller.scrollTo($(this.hash).offset().top - offset)
    if (window.history && window.history.pushState) {
      window.history.pushState('', document.title, $(this).attr('href'))
    }
  })

  $('.keyvisual__megabutton').on('click', function (e) {
    e.preventDefault()
    controller.scrollTo($('#demo').offset().top - offset)
  })

  const toTopScene = new ScrollMagic.Scene({
    triggerElement: '#demo',
    triggerHook: 1
  })
  .setClassToggle('.scroll-to-top', 'active')
  .addTo(controller)

  $('.scroll-to-top').on('click', function () {
    controller.scrollTo(0)
  })
}



// WEBPACK FOOTER //
// ./app/scripts/scroll.js